import React from "react";
import { Link, useNavigate, useOutletContext, useParams } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import DeviceDetailBody, { DeviceDetailBadges } from "./DeviceDetailBody";
import { deviceDisplayName, deviceNameOnly } from "../../utils/deviceName";

/**
 * The /devices/:deviceId route — a deep link. `:deviceId` is Device._id, not
 * the vendor deviceId. Day-to-day the detail opens in a modal from the Devices
 * tab; both render DeviceDetailBody.
 */
export default function DeviceDetail() {
  const { userId, deviceId } = useParams();
  const { deviceIndex } = useOutletContext();
  const navigate = useNavigate();
  const basePath = `/admin/dash/users/${userId}`;

  const device = deviceIndex?.byId?.[deviceId] ?? null;

  return (
    <div>
      <Link
        to={`${basePath}/devices`}
        className="mb-4 inline-flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-slate-900"
      >
        <FiArrowLeft size={16} /> Devices
      </Link>

      {!device ? (
        <p className="rounded-xl border border-slate-200 bg-white p-8 text-center text-sm text-slate-500">
          This device is no longer in the user's account.
        </p>
      ) : (
        <div className="rounded-xl border border-slate-200 bg-white p-6">
          <div className="mb-6 flex flex-wrap items-start justify-between gap-4">
            <div>
              <h2 className="text-xl font-bold text-slate-900">
                {deviceDisplayName(device)}
              </h2>
              {/* Not repeated when the heading is already the id. */}
              {deviceNameOnly(device) && (
                <p className="mt-1 break-all font-mono text-xs text-slate-400">{device.deviceId}</p>
              )}
            </div>
            <div className="flex flex-wrap gap-2">
              <DeviceDetailBadges device={device} />
            </div>
          </div>

          <DeviceDetailBody
            device={device}
            userId={userId}
            onOpenRoom={(room) => navigate(`${basePath}/rooms/${room._id}`)}
            onOpenSchedule={(row) =>
              navigate(`${basePath}/schedules/${row.scheduleId ?? row._id}`)
            }
          />
        </div>
      )}
    </div>
  );
}
